module.exports = __webpack_public_path__ + "img/avatar-s-12.cec148fe.png";